import { AnyAction } from 'redux';

import { createAction, State, Type } from './utils';

export const getInvestigations = (accountId?: number): AnyAction =>
  createAction(State.actionRequested(Type.GET_INVESTIGATIONS), { accountId });

export const doClearGetInvestigations = (): AnyAction => createAction(State.actionCleared(Type.GET_INVESTIGATIONS));
